import React, { useState } from 'react';

const Tooltip = ({ children, text, bgColor, textColor, position = 'top' }) => {
  const [visible, setVisible] = useState(false);

  const getPositionClasses = () => {
    switch (position) {
      case 'bottom':
        return 'top-full left-1/2 transform -translate-x-1/2 mt-2';
      case 'left':
        return 'right-full top-1/2 transform -translate-y-1/2 mr-2';
      case 'right':
        return 'left-full top-1/2 transform -translate-y-1/2 ml-2';
      case 'top':
      default:
        return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
    }
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div
          className={`
            absolute w-[300px] min-w-full h-auto ${getPositionClasses()}
            ${textColor ? textColor : "text-white"}
            ${bgColor ? bgColor : "bg-gray-400"}
            rounded-xl py-1 px-2 z-10
          `}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
